import { gql } from '@apollo/client';

export const CREATE_QUESTION_SKILL = gql`
  mutation createQuestionSkill($input: CreateQuestionSkillInput!) {
    questionSkill {
      create(input: $input) {
        id
        name
        domainId
      }
    }
  }
`;

export const UPDATE_QUESTION_SKILL = gql`
  mutation updateQuestionSkill($input: UpdateQuestionSkillInput!) {
    questionSkill {
      update(input: $input) {
        id
        name
        domainId
      }
    }
  }
`;
